/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.production = process.env.PRODUCTION || "true",
config.sitecoreApiHost = process.env.SITECORE_API_HOST || "https://www.piraeusagencysolutions.gr",
config.sitecoreApiKey = process.env.SITECORE_API_KEY || "{E776FD92-AFDE-4AF2-9938-47E3BCBFF03E}",
config.jssAppName = process.env.JSS_APP_NAME || "piraeusagencysolutions",
config.sitecoreLayoutServiceConfig = process.env.SITECORE_LAYOUT_SERVICE_CONFIG || "sxa-jss",
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || "en",
config.defaultServerRoute = process.env.DEFAULT_SERVER_ROUTE || "/",
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || "sxa-jss",
config.urlOrigin = process.env.URL_ORIGIN || "https://www.piraeusagencysolutions.gr",
config.assetsUrl = process.env.ASSETS_URL || "/dist/piraeusagencysolutions/browser/assets/",
config.searchApiHost = process.env.SEARCH_API_HOST || "",
config.searchPublishEventApiHost = process.env.SEARCH_PUBLISH_EVENT_API_HOST || "",
config.searchDomainId = process.env.SEARCH_DOMAIN_ID || "",
config.searchApiKey = process.env.SEARCH_API_KEY || "",
config.searchApiSource = process.env.SEARCH_API_SOURCE || "",
config.searchViewEventsEnabled = process.env.SEARCH_VIEW_EVENTS_ENABLED || "false",
config.recaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY || "6LdybeYsAAAAADe6YFvxfX9Lejwzb1nIUIer95dp",
config.cookieDomain = process.env.COOKIE_DOMAIN || "019e1b57-788d-7d70-8b60-dc363883df21",
config.notFound404 = process.env.NOT_FOUND404 || "404-page",
config.growthTrackerPath = process.env.GROWTH_TRACKER_PATH || "scripts/piraeusagencysolutions/growthTracker.js",
config.growthTrackingPath = process.env.GROWTH_TRACKING_PATH || "",
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.userWayEnabled = process.env.USER_WAY_ENABLED || "true",
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports.environment = config;